import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaTachometerAlt, FaUser, FaCalendarCheck, FaAward, FaSignOutAlt, FaClipboardList, FaTimes, FaAddressBook } from 'react-icons/fa';

const SidebarLink = ({ to, icon, children, onClick }) => (
  <NavLink
    to={to}
    end
    onClick={onClick}
    className={({ isActive }) =>
      `flex items-center gap-3.5 px-3.5 py-2.5 rounded-xl font-semibold text-sm transition-colors ${
        isActive
          ? 'bg-indigo-900 text-white shadow-sm'
          : 'text-slate-600 hover:bg-slate-100 hover:text-indigo-900'
      }`
    }
  >
    {icon}
    <span>{children}</span>
  </NavLink>
);

const PlayerSidebar = ({ onLogout, isOpen = false, onClose }) => {
  const role = 'player';

  const handleLogout = async () => {
    if (typeof onClose === "function") {
      onClose();
    }
    if (typeof onLogout === "function") {
      await onLogout();
    }
  };

  const handleItemClick = () => {
    if (typeof onClose === "function") {
      onClose();
    }
  };

  return (
    <>
      {/* Mobile Backdrop Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-slate-900/60 backdrop-blur-xs z-40 md:hidden"
          onClick={onClose}
        />
      )}

      <aside
        className={`fixed md:static inset-y-0 left-0 z-50 bg-white w-64 md:min-h-screen p-4 flex flex-col shadow-xl md:shadow-md transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'
        }`}
      >
        <div className="flex items-center justify-between mb-6 px-1">
          <div className="flex items-center gap-2.5">
            <img
              src="/assets/parasports.png"
              alt="Logo"
              className="w-9 h-9 object-contain"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/parasports.png";
              }}
            />
            <div>
              <span className="font-extrabold text-base text-slate-900 block leading-tight">Player Portal</span>
              <span className="text-[10px] text-slate-500 font-semibold uppercase tracking-wider">AP Para Sports</span>
            </div>
          </div>

          {/* Close button for mobile */}
          <button
            onClick={onClose}
            className="md:hidden text-slate-400 hover:text-slate-700 p-1.5 rounded-lg hover:bg-slate-100 transition"
            aria-label="Close menu"
          >
            <FaTimes className="text-lg" />
          </button>
        </div>

        <nav className="flex-grow space-y-1.5 overflow-y-auto">
          {role === 'player' && (
            <>
              <SidebarLink to="/player" icon={<FaTachometerAlt />} onClick={handleItemClick}>Dashboard</SidebarLink>
              <SidebarLink to="/player-profile" icon={<FaUser />} onClick={handleItemClick}>My Profile</SidebarLink>
              <SidebarLink to="/player/my-achievements" icon={<FaAward />} onClick={handleItemClick}>My Achievements</SidebarLink>
              <SidebarLink to="/register-event" icon={<FaClipboardList />} onClick={handleItemClick}>Register Event</SidebarLink>
              <SidebarLink to="/player/my-registrations" icon={<FaCalendarCheck />} onClick={handleItemClick}>My Registrations</SidebarLink>
              <SidebarLink to="/certificates" icon={<FaAward />} onClick={handleItemClick}>My Certificates</SidebarLink>
              <SidebarLink to="/player/district-contacts" icon={<FaAddressBook />} onClick={handleItemClick}>District Contacts</SidebarLink>
            </>
          )}
        </nav>

        <div className="mt-auto pt-4 border-t border-slate-100">
          <button
            onClick={handleLogout}
            className="flex items-center gap-3.5 px-3.5 py-2.5 rounded-xl font-semibold text-sm text-slate-600 hover:bg-red-50 hover:text-red-700 w-full transition-colors"
          >
            <FaSignOutAlt />
            <span>Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default PlayerSidebar;
